import React from 'react';
import MenuJson from '../../data/menu.json';
import BeNavGroup from './nav/nav-group';
import { Nav } from 'react-bootstrap';
import { useUser } from '../../services/redux-services/UserInfoContext';
import { useSignalR } from '../../services/signalR/SignalRProvider';
import { useLanguage } from '../../services/language/LanguageContext';
import ImageViewer from '../image-viewer/ImageViewer';

const MENU_KEYS = {
  '/dashboard': 'nav_dashboard',
  '/transactions': 'nav_transactions',
  '/products': 'nav_products',
  '/stores': 'nav_stores',
  '/users': 'nav_users',
  '/app-chat': 'nav_chat',
};

const MainSidebar = ({ onClose }) => {
  const { user } = useUser();
  const { isConnected } = useSignalR();
  const { t } = useLanguage();

  const initials = `${user?.firstName?.[0] || ''}${user?.lastName?.[0] || ''}`.toUpperCase() || 'A';

  const translatedMenu = MenuJson.map(group => ({
    ...group,
    children: group.children.map(item => ({
      ...item,
      name: MENU_KEYS[item.to] ? t(MENU_KEYS[item.to]) : item.name,
    })),
  }));

  return (
    <div className="main-sidebar-nav default-navigation">
      <button className="sidebar-close-btn" onClick={onClose} aria-label="Close sidebar">
        <i className="fa fa-times" />
      </button>
      <div className="nano has-scrollbar">
        <div className="nano-content sidebar-nav">
          {/* Profile */}
          <div style={styles.profileArea} className="border-bottom">
            {user?.image ? (
              <div style={{ ...styles.avatarCircle, background: 'none', border: '3px solid #e0e7ff', overflow: 'hidden', padding: 0 }}>
                <ImageViewer id={user.image} width={56} preview={false} />
              </div>
            ) : (
              <div style={styles.avatarCircle}>
                {initials}
              </div>
            )}
            <div className="toggle-none" style={{ textAlign: 'center' }}>
              <div style={styles.profileName}>
                {`${user?.firstName || '-'} ${user?.lastName || ''}`}
              </div>
              <div style={styles.profileRole}>
                {user?.userType?.name || t('administrator')}
              </div>
            </div>
            <div style={styles.onlineIndicator} className="toggle-none">
              <span style={{ ...styles.onlineDot, background: isConnected ? '#10b981' : '#9ca3af' }} />
              <span style={{ ...styles.onlineText, color: isConnected ? '#10b981' : '#9ca3af' }}>
                {isConnected ? t('online') : t('offline')}
              </span>
            </div>
          </div>

          {/* Navigation */}
          <Nav as="ul" className="metisMenu flex-column" id="menu">
            {translatedMenu.map((groupItem, key) => (
              <React.Fragment key={key}>
                <li className="nav-heading">
                  <span>{groupItem.groupname.toUpperCase()}</span>
                </li>
                <BeNavGroup menu={groupItem.children} />
              </React.Fragment>
            ))}
          </Nav>
        </div>
      </div>
    </div>
  );
};

const styles = {
  profileArea: {
    padding: '24px 16px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
  },
  avatarCircle: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 4,
    flexShrink: 0,
  },
  profileName: {
    fontSize: 14,
    fontWeight: 600,
    color: '#1f2937',
    lineHeight: 1.3,
  },
  profileRole: {
    fontSize: 12,
    color: '#9ca3af',
    marginTop: 2,
  },
  onlineIndicator: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    marginTop: 2,
  },
  onlineDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: '#10b981',
    display: 'inline-block',
  },
  onlineText: {
    fontSize: 11,
    color: '#10b981',
    fontWeight: 500,
  },
};

export default MainSidebar;
